import {HttpClient,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {TdisAlertService} from 'src/app/shared/services/tdis-alert-service';



@Injectable({ providedIn: 'root' })
export class AuthServerProvider {



    constructor(private http: HttpClient, private jhiAlertService: TdisAlertService, private router: Router) {}

    login(credentials): Observable<any> {

        const loginData = {
            'j_username': credentials.username,
            'j_password': credentials.password
        };
        // const data =
        //     'j_username=' +
        //     encodeURIComponent(credentials.username) +
        //     '&j_password=' +
        //     encodeURIComponent(credentials.password) +
        //     '&remember-me=' +
        //     credentials.rememberMe +
        //     '&submit=Login';
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post(SERVER_API_URL + 'api/authentication', loginData, { headers });
    }

    logout(): Observable<any> {
        // logout from the server
        return this.http.post(SERVER_API_URL + 'api/logout', {}, { observe: 'response' }).map((response: HttpResponse<any>) => {
            // to get a new csrf token call the api
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login']);
            this.jhiAlertService.error('You have successfully logged out', null, null);
            // this.http.get(SERVER_API_URL + 'api/account').subscribe(
            //     () => {},
            //     (res: HttpErrorResponse) => {
            //         this.jhiAlertService.error('You have successfully logged out', null, null);
            //     }
            // );
            return response;
        });
    }

    query(url): Observable<any> {
        return this.http
            .get<any>(SERVER_API_URL+url, {  observe: 'response' });
    }

}
